<template>
  <section class="p-0 bg-login">
    <div class="container">
      <div class="row align-items-center" style="height: 100vh">
        <!-- for large device -->
        <div class="col-lg-6 text-center d-none d-lg-block">
          <img src="assets/img/logo.svg" class="login-logo w-100" />
        </div>

        <div class="col-lg-6 mb-4 pt-5 pt-lg-0">
          <!-- for medium device -->
          <div class="text-center mb-5 d-lg-none">
            <img src="/assets/img/logo.svg" class="login-logo w-100" />
          </div>
          <button type="submit" @click="login()" class="theme-btn border-0">Lets do it 😎!</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Common from "../pages/Firebase/services/Common";
import FirebaseCrud from "../pages/Firebase/services/FirebaseCrud";
export default {
  data() {
    return {
      susi:'',
    }
  },
  methods: {
    login() {
      location.href = "/bookmark"
   
    
    },
  },
}
</script>

<style scoped>
.bg-login {
  background: url('/assets/img/login-bg.png');
  background-size: cover;
  background-attachment: fixed;
}
</style>